import React from "react";
import PropTypes from "prop-types";
import MdSend from "react-icons/lib/md/send";

const SendMsgInput = ({ onMessageSend, value, onTyping, onInputFocus }) => {
  const [inputValue, setInputValue] = React.useState("");
  function sendMessage() {
    if (inputValue.length > 0) onMessageSend(inputValue);
    setInputValue("");
  }

  React.useEffect(() => {
    setInputValue(value);
  }, [value])

  function handleInputChange(event) {
    setInputValue(event.target.value);
    if (onTyping && event.target.value.length > 0) {
      onTyping();
    }
  }

  function handleInputFocus() {
    if (onInputFocus) {
      onInputFocus();
    }
  }

  return (
    <form
      className="send-msg-container"
      onSubmit={event => {
        event.preventDefault();
        sendMessage();
      }}
    >
      <input
        type="text"
        className="send-msg-input"
        autoFocus
        placeholder="Enter your message..."
        onChange={handleInputChange}
        onFocus={handleInputFocus}
        value={inputValue}
      />
      <span className="send-msg-icon" onClick={sendMessage}>
        <MdSend />
      </span>
    </form>
  );
};

export default SendMsgInput;

SendMsgInput.propTypes = {
  onMessageSend: PropTypes.func.isRequired,
  value: PropTypes.string,
  onTyping: PropTypes.func,
  onInputFocus: PropTypes.func
};
